import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';

export default function SocialWidget() {
  return (
    <div className="cs_social_links_wrap">
      <h2>Follow Us</h2>
      <div className="cs_social_links">
        <Link to="https://www.facebook.com/PluroJabalpurFertilityAndIVFCentre" target="_blank" rel="noopener noreferrer">
          <Icon icon="fa-brands:facebook-f" />
        </Link>
        <Link to="https://www.youtube.com/@PluroJabalpur_IVF" target="_blank" rel="noopener noreferrer">
          <Icon icon="fa-brands:youtube" />
        </Link>
        <Link to="https://www.linkedin.com/in/jabalpur-fertility-centre-97504a227/" target="_blank" rel="noopener noreferrer">
          <Icon icon="fa-brands:linkedin-in" />
        </Link>
        <Link to="https://x.com/jabalpurivf1" target="_blank" rel="noopener noreferrer">
          <Icon icon="fa-brands:twitter" />
        </Link>
        <Link to="https://www.instagram.com/plurojabalpur_ivf/" target="_blank" rel="noopener noreferrer">
          <Icon icon="fa-brands:instagram" />
        </Link>
      </div>
    </div>
  );
}
